import { isSuperAdmin } from '../../utils/permissions';
import { useParams } from 'react-router-dom';
import './AccountPage.scss';
import ROUTER from '../../routers/Routers';
import { Icon } from '../../components/icon/icon';
import ButtonIconGhostSmall from '../../components/common/ButtonIconGhost/ButtonIconGhostSmall';
import { Avatar, Col, Row } from 'antd';
import { Divider } from 'antd';
import Tag from '../../components/common/Tag/Tag';
import { useNavigate } from 'react-router-dom';
import ButtonSecondaryMedium from '../../components/common/ButtonSecondary/ButtonSecondaryMedium';
import { Form } from 'antd';
import InputComponent from '../../components/common/InputComponent/InputComponent';
import SelectComponent from '../../components/common/SelectComponent/SelectComponent';
import { Radio } from 'antd';
import DatePickerComponent from '../../components/common/DatePickerComponent/DatePickerComponent';
import ButtonPrimaryMedium from '../../components/common/ButtonPrimary/ButtonPrimaryMedium';
import ButtonSecondarySmall from '../../components/common/ButtonSecondary/ButtonSecondarySmall';
import InputPasswordComponent from '../../components/common/InputPasswordComponent/InputPasswordComponent';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ButtonLink from '../../components/common/ButtonLink/ButtonLink';
import {
  changePassword,
  logout,
  requestChangeEmail,
  requestDeleteAccount,
  updateProfile,
} from '../../store/actions/auth.action';
import { openModal } from '../../components/common/Modal/openModal';
import ButtonSecondaryLarge from '../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';
import CheckboxComponent from '../../components/common/CheckboxComponent/CheckboxComponent';
import { Spin } from 'antd';
import dayjs from 'dayjs';
import ButtonIconGhostMedium from '../../components/common/ButtonIconGhost/ButtonIconGhostMedium';
import { openModalError } from '../../components/common/Modal/openModalError';
import Popover from '../../components/common/Popover/Popover';
import { openModalForm } from '../../components/common/Modal/openModalForm';
import callApi from '../../utils/api/callAPI';
import {
  createAddress,
  deleteAddress,
  fetchFullAddress,
  fetchListAddress,
  fetchProvinces,
  fetchWards,
  updateAddress,
} from '../../store/actions/address.action';
import { message } from 'antd';
import { Empty } from 'antd';
import { openMessageSuccess } from '../../components/common/Message/openMessageSuccess';
import { openMessageWarning } from '../../components/common/Message/openMessageWarning';
import { openMessageError } from '../../components/common/Message/openMessageError';
import {
  addToCart,
  fetchOrder,
  fetchOrders,
} from '../../store/actions/room.action';
import DetailOrderPage from '../DetailOrderPage/DetailOrderPage';
import Chip from '../../components/common/Chip/Chip';
import {
  reloadOrders,
  resetOrdersData,
} from '../../store/reducers/room.reducer';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from '../../components/common/InfiniteScroll/InfiniteScroll';
import TagFittaInstallation from '../../components/common/Tag/TagFittaInstallation';
import formatDateTime from '../../utils/dayjs/formatDateTime.util';
import { t } from 'i18next';
import RenderFulfillmentHistoryStatusTag from '../../components/common/Tag/RenderFulfillmentHistoryStatus';
import RenderPaymentStatusTag from '../../components/common/Tag/RenderPaymentStatus';
import { STATUS_OPTIONS } from '../../constants/constant';
import { useSearchParams } from 'react-router-dom';
import RenderRefundStatus from '../../components/common/Tag/RenderRefundStatus';
import { getValueFromString } from '../../utils/data/getValue.utils';
// import { openDrawerCart } from '../CartPage/components/DrawerCart/DrawerCart';
import { parseJson } from '../../utils/string/parseJson';
import ButtonTertiaryLarge from '../../components/common/ButtonTertiary/ButtonTertiaryLarge';
import { shareDesign } from '../../store/actions/module.action';
import useModalAddress from '../../components/common/ModalAddress/ModalAddress';
import ButtonIconOutlineMedium from '../../components/common/ButtonIconOutline/ButtonIconOutlineMedium';
import { useDeviceType } from '../../hooks/useDeviceType';
import TabComponent from '../../components/common/TabComponent/TabComponent';
import { cn } from '../../utils/string/cn.utils';
import useDrawerCard from '../CartPage/components/DrawerCart/DrawerCart';
import { current } from '@reduxjs/toolkit';
import { convertForeignCurrency } from '../../utils/currency/currency.utils';
import FormAddress from '../../components/common/FormAddress/FormAddress';

const SlugAccountPage = () => {
  const { slug, id } = useParams();
  const { user } = useSelector(state => state.auth);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const device = useDeviceType();

  const listOptions = [
    {
      key: `/${user?.id}`,
      icon: <Icon.ICUser />,
      title: 'Account information',
      children: <AccountInformation />,
    },
    {
      key: ROUTER.ORDER,
      icon: <Icon.ICOrder />,
      title: 'My orders',
      children: <>{id ? <DetailOrderPage /> : <Orders />}</>,
      onClick: () => {
        dispatch(resetOrdersData());
        dispatch(reloadOrders());
      },
    },
    {
      key: ROUTER.PROJECTS,
      icon: <Icon.ICModule />,
      title: 'Design collection',
      children: <DesignCollection />,
    },
    {
      key: ROUTER.ROOMS,
      icon: <Icon.ICBedRoom />,
      title: 'Room collection',
      children: <RoomCollection />,
    },
    {
      key: ROUTER.ADDRESS,
      icon: <Icon.ICLocation />,
      title: 'Address',
      children: <Addresses />,
    },
    {
      key: ROUTER.CHANGE_PASSWORD,
      title: 'Change password',
      icon: <Icon.ICLock />,
      children: <ChangePassword />,
    },
  ];

  const deleteAccount = () => {
    dispatch(
      requestDeleteAccount({ redirect_url: window.location.origin })
    ).then(action => {
      if (action.payload?.data) {
        const modal = openModalForm({
          title: (
            <span className="text-headline-small">
              {t('Request has been sent')}
            </span>
          ),
          content: (
            <div className="p-16">
              <p className="text-body-medium">
                {t(
                  'We will send you an email to confirm the account deletion. Please check your email.'
                )}
              </p>
            </div>
          ),
          footer: [
            <ButtonPrimaryLarge
              title={t('Close')}
              onClick={() => modal.destroy()}
            />,
          ],
        });
      }
    });
  };

  if (device === 'desktop') {
    return (
      <>
        <div className="slug-account-page flex py-32 px-80 items-start gap-40 self-stretch">
          <div
            className="flex flex-col items-center gap-12"
            style={{ minWidth: '220px', width: '220px' }}
          >
            <div className="flex items-center gap-8 self-stretch">
              <Avatar size={40} src={user?.avatar_url} icon={<Icon.ICUser />} />
              <span className="text-label-large ellipsis-multiline-1">
                {user?.fullname}
              </span>
              {/* <ButtonIconGhostSmall icon={<Icon.ICEdit />} /> */}
            </div>
            <Divider type="horizontal" className="m-0 p0" />
            {listOptions.map((item, index) => (
              <ButtonTertiaryLarge
                key={(item, index)}
                className="self-stretch justify-start gap-8 hover:!bg-fills-primary !text-black-high"
                title={
                  <span className="text-body-medium">{t(item.title)}</span>
                }
                active={item.key.includes(slug) || slug === `/${user?.id}`}
                posIcon={item.icon}
                onClick={() => {
                  if (item.onClick) item.onClick();
                  // window.location.href = ROUTER.ACCOUNT + item.key;
                  navigate(ROUTER.ACCOUNT + item.key);
                }}
              />
            ))}
            <Divider type="horizontal" className="m-0 !p-0" />
            <ButtonTertiaryLarge
              className="self-stretch justify-start gap-8 !text-Accents-Red"
              title={<span className="text-body-medium">{t('Logout')}</span>}
              posIcon={<Icon.ICLogOut />}
              onClick={() => {
                dispatch(logout()).then(() => {
                  // window.location.replace('/');
                  navigate('/');
                });
              }}
            />
            <Divider type="horizontal" className="m-0 p0" />
            <ButtonTertiaryLarge
              className="self-stretch justify-start gap-8 !text-Accents-Red"
              title={
                <span className="text-body-medium">{t('Delete account')}</span>
              }
              posIcon={<Icon.ICDelete />}
              onClick={async () => {
                const modal = openModal({
                  title: (
                    <div className="flex self-stretch items-center justify-center">
                      <img src="/assets/icons/icon-delete-account.svg" />
                    </div>
                  ),
                  content: (
                    <>
                      <span className="text-headline-small text-center">
                        {t('Delete account')}
                      </span>
                      <span className="text-body-medium text-center">
                        {t(
                          "We're sorry to see you go. We will send you an email to confirm the account deletion. Please check your email."
                        )}
                      </span>
                    </>
                  ),
                  centered: true,
                  width: 538,
                  classNames: {
                    header: '!p-24 !m-0',
                    footer: '!p-24 gap-16 items-end flex justify-end',
                    body: '!p-24 flex flex-col items-center gap-16',
                  },
                  footer: (
                    <>
                      <ButtonSecondaryLarge
                        title={t('Cancel')}
                        onClick={() => modal.destroy()}
                        className={'self-stretch grow'}
                      />
                      <ButtonPrimaryLarge
                        title={t('Delete')}
                        onClick={() => {
                          modal.destroy();
                          deleteAccount();
                        }}
                        style={{ backgroundColor: '#F08B79' }}
                        className={'self-stretch grow'}
                      />
                    </>
                  ),
                });
              }}
            />
          </div>
          {
            listOptions.find(
              item => item.key.includes(slug) || slug === '/user'
            )?.children
          }
        </div>
      </>
    );
  } else {
    return (
      <>
        {
          listOptions.find(
            item => item.key.includes(slug) || slug === `/${user?.id}`
          ).children
        }
      </>
    );
  }
};

const DesignCollection = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const navigate = useNavigate();
  const [designs, setDesigns] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');
  const [form] = Form.useForm();

  const watchCustomer = Form.useWatch('customer', form);

  const { user, isLoading } = useSelector(state => state.auth);

  const normalizeDesignList = res => {
    const payload = res?.data;
    return payload?.result?.data ?? payload?.data ?? payload?.result ?? [];
  };

  const fetchDesigns = async () => {
    setLoading(true);
    setErr('');
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/users/designs',
        method: 'GET',
        params: {
          country_code,
        },
      });

      // Chuẩn hóa payload
      const payload = res?.data;
      const list =
        payload?.result?.data ?? payload?.data ?? payload?.result ?? [];
      setDesigns(Array.isArray(list) ? list : []);
    } catch (e) {
      setErr(
        e?.data?.error?.message || e?.message || t('Cannot load design list')
      );
    } finally {
      setLoading(false);
    }
  };

  const fetchDesignsByUser = async email => {
    if (!email) {
      setErr(t('Please enter customer email'));
      setDesigns([]);
      return;
    }

    setLoading(true);
    setErr('');
    try {
      const res = await callApi({
        endpoint: `rooms/v3/users/${encodeURIComponent(email)}/designs`,
        method: 'GET',
        params: { country_code },
      });

      const list = normalizeDesignList(res);
      setDesigns(Array.isArray(list) ? list : []);

      if (!list || list.length === 0) {
        setErr(t('No designs found for this email'));
      }
    } catch (e) {
      setErr(
        e?.data?.error?.message ||
          e?.message ||
          t('Cannot load design list by customer')
      );
      setDesigns([]);
    } finally {
      setLoading(false);
    }
  };

  const deleteDesign = async design => {
    if (!design?.id) return;

    try {
      setLoading(true);

      const res = await callApi({
        endpoint: `rooms/v3/design/${design.id}/delete`,
        method: 'DELETE',
      });

      if (res.data?.success) {
        openMessageSuccess({ content: t('Successfully') });
      }

      // Sau khi xóa thành công, tải lại danh sách
      await fetchDesigns();
    } catch (err) {
      openMessageError({
        content:
          err?.data?.error?.message || t('Cannot delete, please try again!'),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!isSuperAdmin(user)) {
      fetchDesigns();
    }
  }, []);

  return (
    <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px]  lg:relative left-0 top-0 right-0 bottom-0 bg-backgrounds-virtual">
      <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch lg:bg-transparent bg-fills-white">
        <ButtonIconOutlineMedium
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden"
        />

        <span className="!font-bold lg:headline-small text-title-large text-center">
          {t('Design collection')}
        </span>
        <span className="lg:hidden"></span>
      </div>
      {isSuperAdmin(user) ? (
        <Form
          layout="horizontal"
          className="flex items-center self-stretch gap-16 lg:p-24 md:px-20 p-16 lg:flex-row flex-col"
          form={form}
          onFinish={values => {
            fetchDesignsByUser(values.customer);
          }}
        >
          <Form.Item
            name={'customer'}
            colon={false}
            label={
              <span className="text-body-medium" style={{ fontWeight: 600 }}>
                Khách hàng
              </span>
            }
            className="self-stretch"
          >
            <InputComponent
              placeholder={t('Enter customer email')}
              className="lg:w-[380px] w-full"
              onKeyDown={e => {
                if (e.key === 'Enter') {
                  form.submit();
                }
              }}
              suffix={
                watchCustomer ? (
                  <ButtonIconGhostSmall
                    icon={<Icon.ICClose />}
                    onClick={() => form.setFieldValue('customer', undefined)}
                  />
                ) : (
                  <></>
                )
              }
            />
          </Form.Item>
          <Form.Item className="self-stretch">
            <ButtonPrimaryMedium
              title={t('Confirm')}
              type={'submit'}
              className="lg:w-[90px] w-full justify-center"
            />
          </Form.Item>
        </Form>
      ) : (
        <></>
      )}

      {loading && (
        <div
          className="flex self-stretch grow justify-center items-center"
          style={{ minHeight: '200px' }}
        >
          <Spin size="large" />
        </div>
      )}

      {/* Hiển thị error */}
      {err && !loading && (
        <div
          className="flex justify-center items-center w-100"
          style={{ color: '#E5654E' }}
        >
          {err}
        </div>
      )}

      {!loading && !err && (
        <>
          <div className="grid xl:grid-cols-3 lg:grid-cols-2 grid-cols-1 lg:items-start lg:justify-start items-center justify-center gap-16 md:px-20 p-16 lg:p-24 lg:self-auto self-stretch overflow-y-auto">
            {designs.length > 0 &&
              designs.map(design => (
                <CardDesign
                  key={design.id}
                  design={design}
                  onDelete={deleteDesign}
                />
              ))}
          </div>
          {!designs.length && (
            <div className="flex items-center justify-center self-stretch grow">
              <Empty />
            </div>
          )}
        </>
      )}
    </div>
  );
};

const RoomCollection = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState('');

  const navigate = useNavigate();

  const fetchRooms = async () => {
    setLoading(true);
    setErr('');
    try {
      const res = await callApi({
        endpoint: 'rooms/v3/users/rooms',
        method: 'GET',
      });

      // Chuẩn hóa payload
      const payload = res?.data;
      const list =
        payload?.result?.data ?? payload?.data ?? payload?.result ?? [];
      setRooms(Array.isArray(list) ? list : []);
    } catch (e) {
      setErr(e?.data?.error?.message || e?.message || t('Cannot load list'));
    } finally {
      setLoading(false);
    }
  };

  const deleteRoom = async room => {
    if (!room?.id) return;

    try {
      setLoading(true);

      const res = await callApi({
        endpoint: `rooms/v3/room/${room.id}/delete`,
        method: 'DELETE',
      });

      if (res.data?.success) {
        openMessageSuccess({ content: t('Successfully') });
      }

      // Sau khi xóa thành công, tải lại danh sách
      await fetchRooms();
    } catch (err) {
      openMessageError({
        content:
          err?.data?.error?.message || t('Cannot delete, please try again!'),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRooms();
  }, []);

  return (
    <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px]  lg:relative left-0 top-0 right-0 bottom-0 bg-backgrounds-virtual">
      <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch lg:bg-transparent bg-fills-white">
        <ButtonIconOutlineMedium
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden"
        />
        <span className="!font-bold lg:headline-small text-title-large text-center">
          {t('Room Collection')}
        </span>
        <span className="lg:hidden"></span>
      </div>
      {loading && (
        <div
          className="flex self-stretch grow justify-center items-center"
          style={{ minHeight: '200px' }}
        >
          <Spin size="large" />
        </div>
      )}

      {/* Hiển thị error */}
      {err && !loading && (
        <div
          className="flex self-stretch grow justify-center items-center"
          style={{ color: '#E5654E' }}
        >
          {err}
        </div>
      )}

      {!loading && !err && (
        <div className="lg:flex grid md:grid-cols-3 grid-cols-2 lg:items-start lg:justify-start items-center justify-center gap-16 p-16 lg:p-24 self-stretch lg:flex-wrap">
          {rooms.length > 0 ? (
            rooms.map(room => (
              <CardRoom key={room.id} room={room} onDelete={deleteRoom} />
            ))
          ) : (
            <div className="flex items-center justify-center self-stretch grow">
              <Empty />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

const AccountInformation = () => {
  const { user, isLoading } = useSelector(state => state.auth);
  const [form] = Form.useForm();
  const [formEmail] = Form.useForm();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const avatarWatch = Form.useWatch('avatar', form);

  // Trong component của bạn:
  const fileInputRef = useRef(null);

  const handleButtonClick = () => {
    fileInputRef.current?.click();
  };

  // 3. Validate file (kiểm tra size, type)
  const normFileWithValidation = e => {
    if (Array.isArray(e)) {
      return e;
    }

    const files = e?.target?.files;
    if (files && files.length > 0) {
      const file = files[0];

      // Validate file size (ví dụ: max 2MB)
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        openMessageWarning({ content: t('Image size must be less than 2 MB') });
        return avatarWatch;
      }

      // Validate file type
      const isImage = file.type.startsWith('image/');
      if (!isImage) {
        openMessageWarning({
          content: t('Only image files are accepted (.png, .jpg, .jpeg)'),
        });
        return avatarWatch;
      }

      const preview = URL.createObjectURL(file);

      return [
        {
          uid: '-1',
          name: file.name,
          status: 'done',
          originFileObj: file,
          url: preview,
        },
      ];
    }

    return [];
  };

  const submit = values => {
    dispatch(
      requestChangeEmail({
        ...values,
        redirect_url: window.location.origin,
      })
    ).then(action => {
      if (action.payload?.data) {
        const modal = openModalForm({
          title: (
            <span className="!font-bold lg:headline-small text-title-large">
              {t('Request completed')}
            </span>
          ),
          content: (
            <div className="p-16">
              <span className="text-body-medium">
                {t(
                  'Please check your Email to complete the email address change.'
                )}
              </span>
            </div>
          ),
          closable: false,
          footer: [
            <ButtonPrimaryLarge
              title={'Đóng'}
              onClick={() => modal.destroy()}
            />,
          ],
        });
      }
    });
  };

  return (
    <>
      <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px] bg-backgrounds-virtual lg:relative left-0 top-0 right-0 bottom-0">
        <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch lg:bg-transparent bg-fills-white">
          <ButtonIconOutlineMedium
            icon={<Icon.ICArrowBack />}
            onClick={() => navigate(-1)}
            className="lg:hidden"
          />
          <span className="!font-bold lg:headline-small text-title-large text-center">
            {t('Account Information')}
          </span>
          <span className="lg:hidden"></span>
        </div>
        <Form
          form={form}
          initialValues={{
            ...user,
            birthday: user?.birthday ? dayjs(user?.birthday) : undefined,
            avatar: [
              {
                uid: '-1',
                url: user?.avatar_url,
              },
            ],
          }}
          onFinish={values => {
            dispatch(
              updateProfile({
                ...values,
                email: undefined,
                avatar: values.avatar[0].originFileObj,
                birthday: values.birthday
                  ? values.birthday.format('YYYY-MM-DD')
                  : undefined,
              })
            ).then(action => {
              if (action.payload?.data) {
                openMessageSuccess({
                  content: t('Profile updated successfully'),
                });
              }
            });
          }}
          layout="vertical"
          className="flex flex-col items-end lg:gap-24 gap-16 self-stretch relative lg:!p-0 md:px-20 p-16"
        >
          <div className="flex lg:flex-row flex-col-reverse items-start justify-start gap-24 self-stretch">
            <div className="flex flex-col justify-center items-start gap-16 self-stretch lg:!p-0 p-16 lg:bg-transparent bg-fills-white rounded-[16px]">
              <Form.Item
                label={t('Fullname')}
                name={'fullname'}
                className="self-stretch lg:w-[536px]"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.length) return Promise.resolve();
                      else return Promise.reject(t('Cannot be empty!'));
                    },
                  },
                ]}
              >
                <InputComponent size="large" placeholder={t('Enter name')} />
              </Form.Item>
              <div className="flex items-end gap-16 self-stretch">
                <Form.Item
                  label="Email"
                  name={'email'}
                  className="self-stretch lg:w-[536px] grow"
                >
                  <InputComponent
                    readOnly={true}
                    size="large"
                    placeholder={t('Enter Email')}
                  />
                </Form.Item>
                <ButtonLink
                  className={'mb-10'}
                  title={
                    <span className="w-fit" style={{ whiteSpace: 'nowrap' }}>
                      {t('Change')}
                    </span>
                  }
                  style={{ color: '#258FD2' }}
                  onClick={() => {
                    const modal = openModalForm({
                      title: (
                        <span className="!font-bold lg:headline-small text-title-large">
                          {t('Change Email Address')}
                        </span>
                      ),
                      form: (
                        <Form
                          layout="vertical"
                          form={formEmail}
                          className="px-24 py-16 flex flex-col items-start gap-16 self-stretch"
                        >
                          <Form.Item
                            label={t('New Email Address')}
                            className="self-stretch"
                            name={'new_email'}
                            rules={[
                              {
                                required: true,
                                message: t('Cannot be empty!'),
                              },
                            ]}
                          >
                            <InputComponent
                              placeholder={t('Enter Email')}
                              size="large"
                              type="email"
                            />
                          </Form.Item>
                        </Form>
                      ),
                      closable: false,
                      footer: (
                        <>
                          <ButtonPrimaryLarge
                            title={t('Confirm')}
                            onClick={() => {
                              try {
                                formEmail
                                  .validateFields(['new_email'])
                                  .then(values => {
                                    submit(values);
                                  })
                                  .catch(_ => {});
                              } catch (error) {}
                            }}
                          />
                        </>
                      ),
                      classNames: {
                        header: '!p-24 !m-0',
                        body: '!p-0',
                        footer: '!p-24 !m-0 items-end flex justify-end gap-16',
                      },
                    });
                  }}
                />
              </div>
              <Form.Item
                label={t('Phone Number')}
                name={'phone'}
                className="self-stretch lg:w-[536px]"
              >
                <InputComponent
                  size="large"
                  rules={[
                    {
                      validator: (_, value) => {
                        if (value?.length) return Promise.resolve();
                        else return Promise.reject(t('Cannot be empty!'));
                      },
                    },
                  ]}
                  addonBefore={
                    <SelectComponent
                      style={{ border: 'none' }}
                      defaultValue={'+84'}
                      options={[
                        {
                          label: (
                            <span className="w-32 h-20 flex">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                style={{ flex: '1 0 0', alignSelf: 'stretch' }}
                                viewBox="0 0 30 20"
                                version="1.1"
                              >
                                <rect width="30" height="20" fill="#da251d" />
                                <polygon
                                  points="15,4 11.47,14.85 20.71,8.15 9.29,8.15 18.53,14.85"
                                  fill="#ff0"
                                />
                                <script xmlns="" />
                              </svg>
                            </span>
                          ),
                          value: '+84',
                        },
                      ]}
                    />
                  }
                  placeholder={t('Enter Phone Number')}
                />
              </Form.Item>
              <Form.Item
                label={t('Gender')}
                name={'gender'}
                className="self-stretch lg:w-[536px]"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value?.length) return Promise.resolve();
                      else return Promise.reject(t('Cannot be empty!'));
                    },
                  },
                ]}
              >
                <Radio.Group>
                  <Radio value="male">{t('Male')}</Radio>
                  <Radio value="female">{t('Female')}</Radio>
                  <Radio value={undefined}>{t('Other')}</Radio>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label={t('Birthday')}
                name={'birthday'}
                className="self-stretch lg:w-[536px]"
                rules={[
                  {
                    validator: (_, value) => {
                      if (value) return Promise.resolve();
                      else return Promise.reject(t('Cannot be empty!'));
                    },
                  },
                ]}
              >
                <DatePickerComponent
                  placeholder={t('Select')}
                  style={{ display: 'flex', flex: '1 0 0' }}
                />
              </Form.Item>
            </div>
            <div
              className="lg:flex hidden flex-col justify-center items-center gap-16"
              style={{ width: '400px' }}
            >
              <div
                style={{
                  width: '112px',
                  height: '112px',
                  borderRadius: '112px',
                  overflow: 'hidden',
                }}
              >
                <Avatar
                  size={112}
                  src={avatarWatch ? avatarWatch[0]?.url : ''}
                  icon={<Icon.ICUser />}
                />
              </div>
              <Form.Item
                name={'avatar'}
                valuePropName="filelist"
                getValueFromEvent={normFileWithValidation}
              >
                <div>
                  <ButtonSecondaryMedium
                    posIcon={<Icon.ICUpload />}
                    title={t('Upload Image')}
                    type={'button'}
                    onClick={handleButtonClick}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/*"
                  />
                </div>
              </Form.Item>

              <span className="text-body-small" style={{ color: '#818589' }}>
                {t('Maximum file size is 1 MB')}
              </span>
            </div>
            <div className="flex lg:hidden px-24 py-16 flex-col items-center gap-[8px] self-stretch rounded-[16px] bg-primary-primaryFillVarient">
              <Avatar size={64} src={user?.avatar_url} icon={<Icon.ICUser />} />
              <Form.Item
                name={'avatar'}
                valuePropName="filelist"
                getValueFromEvent={normFileWithValidation}
              >
                <div>
                  <ButtonSecondaryMedium
                    posIcon={<Icon.ICUpload />}
                    title={t('Upload Image')}
                    type={'button'}
                    onClick={handleButtonClick}
                  />
                  <input
                    ref={fileInputRef}
                    type="file"
                    style={{ display: 'none' }}
                    accept="image/*"
                  />
                </div>
              </Form.Item>
              <span className="text-body-small" style={{ color: '#818589' }}>
                {t('Maximum file size is 1 MB')}
              </span>
            </div>
          </div>
          <Form.Item className="flex justify-end items-end self-stretch lg:self-auto">
            <ButtonPrimaryLarge
              title={t('Cập nhật thông tin')}
              type={'submit'}
              disabled={isLoading}
              loading={isLoading}
              className="w-full"
            />
          </Form.Item>
        </Form>
      </div>
    </>
  );
};

const Addresses = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [form] = Form.useForm();

  const {
    handleData,
    openModalListAddress,
    deliveryAddress,
    setDeliveryAddress,
    form: formAddress,
    listAdd,
    setListAdd,
    listAddress,
    provinces,
    wards,
    addAddress,
    editAddress,
    removeAddress,
    openModalAddAddress,
    // setListAdd,
  } = useModalAddress({
    handleUpdateAddress: addressId => {
      // dispatch(
      //   updateOrder({ billAddress: addressId, id: order.detail.id })
      // ).then(action => {
      //   if (action.payload?.data) {
      //     openMessageSuccess({ content: t('Successfully') });
      //   }
      // });
    },
  });

  useEffect(() => {
    if (listAddress.isNeedReloadData) dispatch(fetchListAddress());
  }, [listAddress]);

  useEffect(() => {
    if (listAddress.data.length > 0) {
      setListAdd([...(listAddress.data ?? [])]);
      handleData();
    }
  }, [listAddress]);

  return (
    <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px]  lg:relative left-0 top-0 right-0 bottom-0 bg-backgrounds-virtual">
      <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch bg-fills-white lg:bg-transparent lg:justify-between">
        <ButtonIconOutlineMedium
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden"
        />
        <span className="!font-bold lg:headline-small text-title-large text-center">
          {t('Address')}
        </span>
        <span className="lg:hidden"></span>
        <ButtonPrimaryMedium
          title={t('Add new address')}
          posIcon={<Icon.ICAdd />}
          className="lg:flex hidden"
          onClick={() => {
            openModalAddAddress();
          }}
        />
      </div>
      <div className="flex flex-col md:p-32 p-16 justify-start items-start gap-16 self-stretch">
        {listAddress.isLoading && (
          <div className="flex items-center justify-center self-stretch grow">
            <Spin spinning={listAddress.isLoading} />
            {listAddress.data.length === 0 && !listAddress.isLoading && (
              <Empty />
            )}
          </div>
        )}

        {listAdd.map((item, index) => {
          return (
            <div
              key={index}
              className="card-address flex p-16 flex-col items-start gap-12 self-stretch rounded-[16px] bg-fills-white shadow-dropshadow2"
            >
              <div className="flex justify-between items-center self-stretch">
                <div className="flex items-center gap-16">
                  <Tag
                    className="bg-[#E3EFFB] text-[#145B90]"
                    label={
                      <span className="text-label-medium">
                        {item.address_name}
                      </span>
                    }
                  />
                  {item.is_default && (
                    <span className="text-label-medium text-[#258FD2] font-semibold">
                      {t('Default address')}
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-12">
                  {!item.is_default && (
                    <ButtonSecondarySmall
                      title={t('Default address')}
                      onClick={() => {
                        editAddress({ ...item, is_default: true }, () => {});
                      }}
                    />
                  )}
                  <ButtonSecondarySmall
                    title={t('Edit')}
                    onClick={() => {
                      formAddress.setFieldsValue({ ...item });
                      const modal = openModalForm({
                        title: (
                          <span className="!font-bold lg:headline-small text-title-large">
                            {t('Update shipping address')}
                          </span>
                        ),
                        width: 600,
                        form: <FormAddress form={formAddress} />,
                        footer: (
                          <>
                            <ButtonPrimaryLarge
                              title={t('Update address')}
                              onClick={() => {
                                formAddress
                                  .validateFields()
                                  .then(values => {
                                    editAddress(
                                      { ...values, id: item.id },
                                      () => modal.destroy()
                                    );
                                  })
                                  .catch(_ => {});
                              }}
                            />
                          </>
                        ),
                        closable: false,
                        classNames: {
                          header: 'lg:!p-24 !p-16 m-0',
                          body: '!p-0',
                          footer:
                            'lg:!p-24 !p-16 items-end flex justify-end gap-16 !mt-0',
                          content: '!rounded-[16px]',
                        },
                      });
                    }}
                  />
                  {!item.is_default && (
                    <ButtonSecondarySmall
                      title={t('Delete')}
                      className="warning"
                      onClick={() => removeAddress(item.id)}
                    />
                  )}
                </div>
              </div>
              <div className="flex items-center gap-[8px] grow self-stretch">
                <span className="text-label-large font-semibold text-black-high">
                  {item.contact_name}
                </span>
                <Divider type="vertical" className="m-0 !p-0" />
                <span className="text-body-large text-black-medium">
                  {item.phone}
                </span>
              </div>
              <span className="text-body-medium text-black-medium">
                {`${item.addressFull ?? '...'}`}
              </span>
            </div>
          );
        })}
        <ButtonPrimaryLarge
          title={t('Add new address')}
          posIcon={<Icon.ICAdd />}
          className="lg:hidden self-stretch"
          onClick={() => {
            openModalAddAddress();
          }}
        />
      </div>
    </div>
  );
};

const Orders = () => {
  // Trạng thái chưa đúng
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { order } = useSelector(state => state.room);

  const [searchParams, setSearchParams] = useSearchParams();
  const statusParam = searchParams.get('fulfillment_status') || null;
  const kwParam = searchParams.get('kw') || null;

  const [offset, setOffset] = useState(0);

  const updateSearchParams = useCallback(
    (key, value) => {
      const params = Object.fromEntries([...searchParams]);

      if (value !== null && value !== undefined && value !== '') {
        params[key] = value;
        if (key !== 'offset') {
          setOffset(0);
        }
        setSearchParams({ ...params });
      } else {
        delete params[key];
        setSearchParams(params);
      }
    },
    [searchParams]
  );

  const renderProjectItems = items => {
    return items.map((item, index) => {
      const total = item.price_after;
      return (
        <div key={index} className="flex items-center self-stretch gap-[8px]">
          <div className="flex items-center grow gap-24">
            <div
              className={`aspect-square w-[60px] h-[60px] rounded-[4px] opacity-60 `}
              style={{
                backgroundImage: `url(${item.thumbnail})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
              }}
            />
            <span className="text-body-large font-semibold">
              {getValueFromString(item.item_name)}
            </span>
          </div>
          <div className="lg:flex hidden flex-col justify-center items-start w-[250px] gap-[8px]">
            <TagFittaInstallation />
          </div>
          <div className="flex flex-col justify-center items-start w-[40px] gap-[8px]">
            <span className="text-body-medium">x1</span>
          </div>
          <div className="flex flex-col justify-center items-start w-[112px] gap-[8px]">
            <span className="text-body-medium">
              {convertForeignCurrency(total)}
            </span>
          </div>
        </div>
      );
    });
  };

  const loadMoreData = useCallback(async () => {
    dispatch(
      fetchOrders({
        offset: offset ?? 0,
        limit: 5,
        fulfillment_status: !statusParam?.includes(',') ? statusParam : null,
        fulfillment_status_range: statusParam?.includes(',')
          ? statusParam
          : null,
        kw: kwParam?.length ? kwParam : null,
      })
    ).then(action => {
      if (action.payload?.data)
        setOffset(order.data.length + action.payload.data.length);
    });
  }, [statusParam, kwParam, offset]);

  const renderRemindPayment = (payStep, id) => {
    return (
      <div className="flex z-10 p-24 mt-[-16px] justify-between items-center gap-[32px] self-stretch rounded-[16px] bg-[#EDFAFF]">
        <span className="text-body-medium">
          {payStep === 0
            ? t(
                'Your order has been created but not yet completed payment. Please continue to pay to complete the order.'
              )
            : payStep === 1
              ? t(
                  'The order has reached the second payment stage. Please continue to pay so your order can be delivered to you.'
                )
              : payStep === 2
                ? t(
                    'Your order is almost complete. Please proceed with the final payment to receive your order.'
                  )
                : null}
        </span>
        <ButtonPrimaryMedium
          title={t('Pay now')}
          className="min-w-[140px]"
          onClick={() => {
            dispatch(fetchOrder({ id: id })).then(action => {
              if (action.payload?.data) {
                navigate(ROUTER.PAYMENT, {
                  state: {
                    data: {
                      ...(action.payload?.data ?? {}),
                    },
                  },
                });
              }
            });
          }}
        />
      </div>
    );
  };

  useEffect(() => {
    setOffset(0);
  }, []);

  useEffect(() => {
    if (order.isNeedReloadData) loadMoreData();
  }, [order]);

  return (
    <>
      <Spin fullscreen spinning={order.detailIsLoading} size="large" />
      <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px]  lg:relative left-0 top-0 right-0 bottom-0 bg-backgrounds-virtual">
        <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch lg:bg-transparent bg-fills-white gap-16">
          <ButtonIconOutlineMedium
            icon={<Icon.ICArrowBack />}
            onClick={() => navigate(-1)}
            className="lg:hidden"
          />
          <span className="!font-bold lg:headline-small text-title-large text-center">
            {t('Order')}
          </span>
          <span className="lg:hidden"></span>
          <div className="lg:flex hidden items-center self-stretch gap-[8px] overflow-x-auto">
            {[
              {
                label: 'In progress',
                value: '0,6',
              },
              {
                label: 'Received',
                value: '7',
              },
              {
                label: 'Cancelled',
                value: '8',
              },
            ].map((item, index) => (
              <Chip
                key={index}
                active={statusParam === item.value}
                className="bg-[#E0E0E0] rounded-[1000px] py-[7px] px-16 h-[30px] w-fit"
                label={
                  <span className="text-label-medium font-semibold ">
                    {t(item.label)}
                  </span>
                }
                onClick={() => {
                  // updateSearchParams('status', index);

                  updateSearchParams('fulfillment_status', item.value);
                  dispatch(resetOrdersData());
                  setTimeout(() => {
                    dispatch(reloadOrders());
                  }, 100);
                }}
              />
            ))}
          </div>
        </div>
        <div className="flex lg:hidden md:px-20 p-16 items-center gap-16 self-stretch bg-fills-white">
          <TabComponent
            items={[
              {
                label: t('In progress'),
                key: '0,6',
              },
              {
                label: t('Received'),
                key: '7',
              },
              {
                label: t('Cancelled'),
                key: '8',
              },
            ]}
            className=" [&_.ant-tabs-content-holder]:hidden w-fit"
            defaultActiveKey={statusParam}
            onChange={value => {
              updateSearchParams('fulfillment_status', item.value);
              dispatch(resetOrdersData());
              setTimeout(() => {
                dispatch(reloadOrders());
              }, 100);
            }}
          />
        </div>

        {order.isLoading && order.data.length === 0 ? (
          <div className="flex self-stretch grow items-center justify-center">
            <Spin spinning size="large" />
          </div>
        ) : (
          <InfiniteScroll
            className="flex lg:p-[4px] md:px-20 p-16 justify-start items-start gap-16 flex-col"
            dataLength={order.data?.length ?? 0}
            next={loadMoreData}
            hasMore={order.data.length < order.total}
            // isLoading={order.isLoading}
            scrollableTarget={'scrollableDiv'}
          >
            {order.data.map((item, index) => {
              const itemList = (() => {
                try {
                  return parseJson(item.items);
                } catch (error) {
                  return [];
                }
              })();
              const coupons = (() => {
                try {
                  return parseJson(item.coupons);
                } catch (error) {
                  return [];
                }
              })();
              // const totalCoupons = coupons.reduce((prev, curr) => {
              //   const temp = prev;
              //   return temp + (curr.amount ?? 0);
              // }, 0);
              const totalPrice =
                (item.amount ?? 0) -
                (item.discount ?? 0) +
                (item.shipping_fee ?? 0);
              const percentPayment = (() => {
                if (item.type === 1 && item.amount_paid === 0) {
                  return 1;
                } else if (item.type === 1 && item.amount_paid === totalPrice) {
                  return 0;
                } else if (item.paid_step === 0) {
                  return 0.5;
                } else if (item.paid_step === 1) {
                  return 0.3;
                } else {
                  return 0.2;
                }
              })();

              return (
                <div className="flex flex-col items-start self-stretch grow">
                  <div
                    key={index}
                    onClick={() => {
                      navigate(ROUTER.ACCOUNT + '/order/' + item.id);
                    }}
                    className="flex cursor-pointer z-20 p-24 flex-col items-start gap-12 self-stretch rounded-[16px] border-[1px] border-solid border-[#E0E0E0] bg-fills-white"
                  >
                    <div className="flex items-start gap-16 self-stretch flex-col lg:flex-row">
                      <div className="flex items-center gap-[8px] grow">
                        <span className="flex justify-center items-center aspect-square w-24 h-24 gap-[10px]">
                          <Icon.ICCart />
                        </span>
                        <span className="text-title-medium">{item.code}</span>
                        <Divider type="vertical" className="m-0 !p-0 h-24" />
                        <span className="text-body-medium">
                          {t('Order date')}{' '}
                          {formatDateTime(item.created_at, 'dateFormat.date')}
                        </span>
                      </div>
                      <div className="flex items-center gap-12 self-stretch">
                        {item.fulfillment_status === 8 ? (
                          <RenderRefundStatus
                            status={(() => {
                              if (
                                (!item.refund_transactions?.length ||
                                  item.refund_transactions?.some(
                                    item => item.status === 0
                                  )) &&
                                item.payment_transactions?.length
                              )
                                return 0;
                              else return 1;
                            })()}
                          />
                        ) : (
                          <RenderPaymentStatusTag
                            type={item.type}
                            step={item.paid_step}
                          />
                        )}

                        <RenderFulfillmentHistoryStatusTag
                          orderType={item.order_type}
                          status={item.fulfillment_status}
                        />
                      </div>
                    </div>
                    <Divider type="horizontal" className="m-0 !p-0" />
                    <div className="flex flex-col items-start gap-[4px] self-stretch">
                      {renderProjectItems(itemList)}
                    </div>
                    <Divider type="horizontal" className="m-0 !p-0" />
                    <div className="flex justify-end items-center gap-24 self-stretch grow">
                      {/* <div className="flex items-center gap-16 grow justify-start">
                  <ButtonSecondarySmall
                    posIcon={<Icon.ICDescription />}
                    title={'Xem chi tiết'}
                  />
                  <ButtonSecondarySmall
                    posIcon={<Icon.ICDownload />}
                    title={'Tải hóa đơn'}
                  />
                </div> */}
                      {item.paid_step < 3 ? (
                        <div className="flex flex-col items-end justify-end gap-[8px]">
                          <div className="flex items-center gap-8">
                            <span
                              className="text-body-small"
                              style={{ color: '#5A5D60' }}
                            >
                              {t('Subtotal')}
                            </span>
                            <span className="text-label-small flex gap-4 items-center">
                              {convertForeignCurrency(totalPrice)}
                            </span>
                          </div>
                          <div className="flex items-center gap-8">
                            <span
                              className="text-body-small"
                              style={{ color: '#5A5D60' }}
                            >
                              {t('Paid amount')}
                            </span>
                            <span className="text-label-small flex gap-4 items-center">
                              {convertForeignCurrency(item.amount_paid)}
                            </span>
                          </div>
                          <div className="flex items-center gap-8">
                            <span
                              className="text-body-large"
                              style={{ color: '#5A5D60' }}
                            >
                              {t('Amount due')}
                            </span>
                            <span className="text-label-large flex gap-4 items-center">
                              {convertForeignCurrency(
                                totalPrice * percentPayment
                              )}
                            </span>
                          </div>
                        </div>
                      ) : (
                        <div className="flex items-center gap-8">
                          <span
                            className="text-body-large"
                            style={{ color: '#5A5D60' }}
                          >
                            {t('Total price')}
                          </span>
                          <span className="text-label-large flex gap-4 items-center">
                            {convertForeignCurrency(totalPrice)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                  {(() => {
                    if (item.paid_step === 0 && item.fulfillment_status >= 0) {
                      return renderRemindPayment(0, item.id);
                    } else if (
                      item.paid_step <= 1 &&
                      item.fulfillment_status >= 3 &&
                      item.order_type !== 2
                    ) {
                      return renderRemindPayment(1, item.id);
                    } else if (
                      item.paid_step <= 1 &&
                      item.fulfillment_status >= 2 &&
                      item.order_type === 2
                    ) {
                      return renderRemindPayment(1, item.id);
                    } else if (
                      item.paid_step <= 2 &&
                      item.fulfillment_status === 5
                    ) {
                      return renderRemindPayment(2, item.id);
                    }
                  })()}
                </div>
              );
            })}
          </InfiniteScroll>
        )}
      </div>
    </>
  );
};

const ChangePassword = () => {
  const [errors, setErrors] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return (
    <div className="flex lg:p-24 flex-col items-start lg:gap-24 grow rounded-[8px]  lg:relative left-0 top-0 right-0 bottom-0 bg-backgrounds-virtual">
      <div className="lg:flex lg:!p-0 md:px-20 p-16 grid grid-cols-3 items-center self-stretch lg:bg-transparent bg-fills-white gap-16">
        <ButtonIconOutlineMedium
          icon={<Icon.ICArrowBack />}
          onClick={() => navigate(-1)}
          className="lg:hidden"
        />
        <span className="!font-bold lg:headline-small text-title-large text-center">
          {t('Change Password')}
        </span>
        <span className="lg:hidden"></span>
      </div>
      <Form
        layout="vertical"
        className="flex flex-col items-start gap-24 self-stretch lg:p-24 lg:m-0 m-20 lg:max-w-[600px]"
        onFinish={values => {
          dispatch(changePassword({ ...values }));
        }}
      >
        <div className="flex p-16 lg:p-0 lg:bg-transparent bg-fills-white rounded-[16px] flex-col gap-24 self-stretch lg:shadow-none shadow-dropshadow2">
          <Form.Item
            label={t('Current Password')}
            name={'old_password'}
            className="self-stretch"
            help={false}
            rules={[{ required: true }]}
          >
            <InputPasswordComponent
              placeholder={t('Enter current password')}
              visible={false}
              size={'large'}
            />
          </Form.Item>
          <Form.Item
            label={t('New Password')}
            name={'new_password'}
            className="self-stretch"
            help={false}
            dependencies={['currentPassword']}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  const errors = [];
                  if (value.length < 8) {
                    errors.push(
                      t('Password must be at least 8 characters long.')
                    );
                  }
                  if (!/[A-Z]/.test(value)) {
                    errors.push(
                      t('Password must have at least 1 uppercase letter.')
                    );
                  }
                  if (!/[0-9]/.test(value)) {
                    errors.push(t('Password must have at least 1 digit.'));
                  }
                  if (!/[!@#$%^&*()]/.test(value)) {
                    errors.push(
                      t(
                        'Password must have at least 1 special character !@#$%^&*().'
                      )
                    );
                  }
                  if (!value || getFieldValue('currentPassword') === value) {
                    errors.push(
                      t(
                        'New password must be different from the current password.'
                      )
                    );
                  }
                  if (errors.length > 0) {
                    setErrors(errors);
                    return Promise.reject(new Error());
                  }
                  setErrors([]);
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <InputPasswordComponent
              placeholder={t('Enter new password')}
              visible={false}
              size={'large'}
            />
          </Form.Item>
          {errors.length > 0 && (
            <ul
              className="flex flex-col justify-start items-start gap-4 self-stretch m-0"
              style={{ color: '#818589' }}
            >
              {errors.map((error, index) => (
                <li key={index}>
                  <span className="text-body-small">{error}</span>
                </li>
              ))}
            </ul>
          )}
          <Form.Item
            label={t('Confirm Password')}
            name={'confirmPassword'}
            className="self-stretch"
            help={false}
            rules={[
              { required: true },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue('new_password') === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject();
                },
              }),
            ]}
          >
            <InputPasswordComponent
              placeholder={t('Enter confirm password')}
              visible={false}
              size={'large'}
            />
          </Form.Item>
        </div>
        <Form.Item className="lg:self-auto self-stretch">
          <ButtonPrimaryLarge
            title={t('Change Password')}
            type={'submit'}
            className="lg:w-[340px] w-full justify-center"
          />
        </Form.Item>
      </Form>
    </div>
  );
};

const CardDesign = ({ design, onDelete, ...props }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { products } = useSelector(state => state.product);

  const { openDrawerCart } = useDrawerCard();

  const formatTimeAgo = dateString => {
    if (!dateString) return '--';
    const date = dayjs(dateString);
    const now = dayjs();
    const diff = now.diff(date, 'day');

    if (diff === 0) return t('Today');
    if (diff === 1) return t('Yesterday');
    if (diff < 7) return `${diff} ${t('days ago')}`;
    if (diff < 30) return `${Math.floor(diff / 7)} ${t('weeks ago')}`;
    return date.format('DD/MM/YYYY');
  };

  // Handler khi click vào card
  const handleEditClick = () => {
    console.log(design);
    if (design?.id) {
      const product = products?.data?.find(item =>
        // Array.isArray(item.types) &&
        item.types.some(t => t?.id === design.type)
      );
      navigate(
        ROUTER.DESIGN +
          '/' +
          (product?.type_design || design?.type_design) +
          `?design_id=${design.id}`
      );
    }
  };

  const handleCardClick = e => {
    if (design?.id) {
      const product = products?.data?.find(item =>
        // Array.isArray(item.types) &&
        item.types.some(t => t?.id === design.type)
      );
      const url =
        ROUTER.DESIGN +
        '/' +
        (product?.type_design || design.type_design) +
        `?design_id=${design.id}`;
      if (e?.ctrlKey || e?.metaKey) {
        window.open(url, '_blank');
      } else {
        navigate(url);
      }
    }
  };

  // // Handler cho button Edit riêng
  // const handleEditClick = e => {
  //   e.stopPropagation(); // Ngăn trigger click card
  //   if (design?.id) {
  //     navigate(
  //       ROUTER.DESIGN + '/' + design.type_design + `?design_id=${design.id}`
  //     );
  //   }
  // };

  const handleDownloadClick = e => {
    e?.stopPropagation?.();

    const url = design?.su_file_url;
    if (!url) {
      message.error(t('Design file not available for download.'));
      return;
    }

    // Tạo thẻ a ẩn để download
    const a = document.createElement('a');
    a.href = url;

    // Đặt tên file (tuỳ bạn, có thể lấy từ URL)
    const fileNameFromUrl = url.split('/').pop()?.split('?')[0] || 'design.su';
    a.setAttribute('download', design?.name || fileNameFromUrl);

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleShareDesign = (e, designId) => {
    e?.stopPropagation?.();

    const modal = openModalForm({
      title: (
        <span className="text-headline-small">
          {t('Share the design to another account')}
        </span>
      ),
      width: 800,
      form: (
        <Form layout="vertical" form={form} className="h-[160px] px-24 py-16">
          <Form.Item
            name={'toUserEmail'}
            label={t('Receiver Email')}
            className="self-stretch"
          >
            <InputComponent
              type="email"
              size="large"
              placeholder={t('Enter email')}
            />
          </Form.Item>
        </Form>
      ),
      destroyOnHidden: true,
      afterClose: () => {
        form.resetFields(['toUserEmail']);
      },
      footer: (
        <div className="p-24 items-end flex justify-end gap-16">
          <ButtonSecondaryLarge
            title={t('Cancel')}
            onClick={() => {
              modal.destroy();
            }}
          />
          <ButtonPrimaryLarge
            title={t('Share')}
            onClick={() => {
              form
                .validateFields()
                .then(values => {
                  dispatch(shareDesign({ designId, ...values })).then(
                    action => {
                      if (action.payload?.error) {
                        openMessageError({ content: t('Failed') });
                        return;
                      }
                      openMessageSuccess({ content: t('Successfully') });
                      modal.destroy();
                    }
                  );
                })
                .catch(_ => {});
            }}
          />
        </div>
      ),
      classNames: {
        header: '!p-24 !m-0',
        body: '!p-0',
        footer: '!mt-[0px]',
      },
    });
  };

  const handleDeleteClick = () => {
    // e.stopPropagation();

    const modal = openModalError({
      title: (
        <span className="text-title-medium" style={{ fontWeight: '700' }}>
          {t('Delete design')}
        </span>
      ),
      footer: (
        <>
          <ButtonSecondaryLarge
            title={t('Cancel')}
            onClick={() => modal.destroy()}
          />
          <ButtonPrimaryLarge
            title={t('Delete')}
            onClick={async () => {
              try {
                // gọi hàm onDelete truyền từ parent (nếu có)
                if (onDelete && design?.id) {
                  await onDelete(design);
                }
              } finally {
                modal.destroy();
              }
            }}
            style={{ backgroundColor: '#F08B79' }}
          />
        </>
      ),
    });
  };

  return (
    <div
      {...props}
      className={cn(
        'card-item flex flex-col items-start rounded-[8px] lg:gap-12 lg:p-12 gap-[8px] p-[8px] lg:w-[290px] w-full cursor-pointer bg-white',
        props.className
      )}
      onClick={handleCardClick}
    >
      <div className="flex self-stretch relative items-center justify-center overflow-hidden lg:h-[266px] h-[161px] ">
        <img
          src={design?.thumbnail_url || '/assets/images/bep-tren.png'}
          alt={design?.name || 'Design'}
          className="w-full h-full object-cover rounded-[4px]"
        />
      </div>
      <div className="flex flex-col justify-start items-start gap-4 self-stretch">
        <span className="text-body-medium" style={{ fontWeight: 600 }}>
          {getValueFromString(design?.name)}
        </span>
        <span className="text-body-medium" style={{ color: '#AAB2B6' }}>
          {formatTimeAgo(design?.updated_at || design?.created_at)}
        </span>
        <span className="text-body-medium" style={{ color: '#AAB2B6' }}>
          {convertForeignCurrency(design?.price_after)}
        </span>
      </div>
      <div className="flex pt-[8px] justify-end items-end gap-16 self-stretch card-room-button">
        <ButtonSecondaryMedium
          title={t('Cart')}
          posIcon={<Icon.ICAddToCart />}
          className={'grow'}
          onClick={e => {
            e.stopPropagation();
            if (design.is_completed) {
              dispatch(addToCart({ designId: design.id })).then(action => {
                if (action.payload?.data)
                  openMessageSuccess({
                    content: t('Success.added_to_cart'),
                  });
                openDrawerCart();
              });
            } else {
              openMessageWarning({ content: t('Please complete the design') });
            }
          }}
        />
        <ButtonIconGhostMedium
          icon={<Icon.ICEdit />}
          onClick={e => {
            e.stopPropagation();
            handleEditClick();
          }}
          className="lg:flex hidden"
        />
        <Popover
          items={[
            {
              posIcon: <Icon.ICSendSomething />,
              label: t('Share the design to another account'),
              className: 'text-black-high items-start justify-start',
              onClick: e => handleShareDesign(e, design.id),
            },
            {
              posIcon: <Icon.ICDownLoadDesign />,
              label: t('Download Design'),
              className: 'text-black-high items-start justify-start',
              onClick: handleDownloadClick,
            },
            {
              posIcon: <Icon.ICDelete />,
              label: t('Delete Design'),
              diffGroup: true,
              className: 'text-Accents-Red items-start justify-start',
              onClick: handleDeleteClick,
            },
          ]}
        >
          <span
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <ButtonIconGhostMedium icon={<Icon.ICMoreVert />} />
          </span>
        </Popover>
      </div>
    </div>
  );
};

const CardRoom = ({ room, onDelete, ...props }) => {
  const formatTimeAgo = dateString => {
    if (!dateString) return '--';
    const date = dayjs(dateString);
    const now = dayjs();
    const diff = now.diff(date, 'day');

    if (diff === 0) return t('Today');
    if (diff === 1) return t('Yesterday');
    if (diff < 7) return `${diff} ${t('days ago')}`;
    if (diff < 30) return `${Math.floor(diff / 7)} ${t('weeks ago')}`;
    return date.format('DD/MM/YYYY');
  };

  const handleDeleteClick = () => {
    // e.stopPropagation();

    const modal = openModalError({
      title: (
        <span className="text-title-medium" style={{ fontWeight: '700' }}>
          {t('Delete Room')}
        </span>
      ),
      footer: (
        <>
          <ButtonSecondaryLarge
            title={t('Cancel')}
            onClick={() => modal.destroy()}
          />
          <ButtonPrimaryLarge
            title={t('Delete')}
            onClick={async () => {
              try {
                // gọi hàm onDelete truyền từ parent (nếu có)
                if (onDelete && room?.id) {
                  await onDelete(room);
                }
              } finally {
                modal.destroy();
              }
            }}
            style={{ backgroundColor: '#F08B79' }}
          />
        </>
      ),
    });
  };

  return (
    <div
      {...props}
      className={cn(
        'card-item flex flex-col items-start rounded-[8px] lg:gap-12 lg:p-12 lg:w-[290px] gap-[8px] p-[8px] w-full bg-white',
        props.className
      )}
    >
      <div className="flex self-stretch relative items-center justify-center overflow-hidden lg:h-[266px] h-[161px]">
        <img
          src={room?.thumbnail || '/assets/images/bep-tren.png'}
          alt=""
          className="object-fit-contain"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover ',
          }}
        />
        <ButtonIconGhostSmall
          icon={<Icon.ICDelete />}
          className={'absolute top-8 right-8 button-delete'}
        />
      </div>
      <div className="flex flex-col justify-start items-start gap-4 self-stretch relative">
        <span className="text-body-medium" style={{ fontWeight: 600 }}>
          {room?.name || '--'}
        </span>
        <span className="text-body-medium" style={{ color: '#AAB2B6' }}>
          {formatTimeAgo(room?.createdAt || room?.created_at)}
        </span>
        <Popover
          items={[
            {
              posIcon: <Icon.ICDelete />,
              label: t('Delete Room'),
              style: { color: '#E5654E' },
              onClick: handleDeleteClick,
            },
          ]}
        >
          <ButtonIconGhostSmall
            icon={<Icon.ICMoreVert />}
            className={'absolute top-0 right-0'}
          />
        </Popover>
      </div>
    </div>
  );
};

export { SlugAccountPage, FormAddress };
